import './../../scss/blocks/_about.scss'

const initAboutSlider = () => {
    const sliders = document.querySelectorAll('[data-about-slider]')
    if (!sliders.length) {
        return
    }

    const mql = window.matchMedia('(max-width: 799px)')

    const apply = () => {
        sliders.forEach((sliderEl) => {
            const shouldInit = mql.matches

            if (shouldInit && !sliderEl._swiper) {
                const args = {
                    slidesPerView: 1.15,
                    spaceBetween: 16,
                    speed: 450,
                    watchOverflow: true,
                }

                // eslint-disable-next-line no-undef
                sliderEl._swiper = new Swiper(sliderEl, args)
            }

            if (!shouldInit && sliderEl._swiper) {
                sliderEl._swiper.destroy(true, true)
                sliderEl._swiper = null
            }
        })
    }

    apply()
    mql.addEventListener('change', apply)
}

document.addEventListener('DOMContentLoaded', () => {
    initAboutSlider()
})
